module.exports = __webpack_public_path__ + "img/report.1863189b.png";